<template>
  <div>
    <el-form :inline="true">
      <!-- 添加/搜索区域 -->
      <el-form-item>
        <el-button @click="addarea">{{ $t('xinzeng') }}</el-button>
      </el-form-item>
      <!-- 列表区域 -->
      <el-form-item>
        <el-input
          v-model="queryinfo.query"
          :clearable="true"
          @clear="getlist"
          style="width:240px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getlist"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="arealist" border style="width: 100%;">
      <el-table-column prop="id" label="#"></el-table-column>
      <el-table-column prop="code" :label="$t('xt.quhao')"></el-table-column>
      <el-table-column prop="cnname" :label="$t('xt.zwmc')"> </el-table-column>
      <el-table-column prop="enname" :label="$t('xt.ywmc')"></el-table-column>
      <el-table-column :label="$t('caozuo')" width="150px">
        <template slot-scope="{ row }">
          <el-tooltip
            :content="$t('bianji')"
            placement="top"
            :enterable="false"
          >
            <i class="iconfont icon-bianji" @click="edit(row.id)"></i>
          </el-tooltip>
          <el-tooltip
            :content="$t('shanchu')"
            placement="top"
            :enterable="false"
          >
            <i class="el-icon-close" @click="del(row.id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      :hide-on-single-page="total <= 10"
      background
      layout="prev, pager, next, total"
      :page-size="10"
      :total="total"
      :current-page="queryinfo.page"
      @current-change="changepage"
    ></el-pagination>
    <!-- 添加区号弹窗区域 -->
    <el-dialog
      :title="$t('xinzeng')"
      :visible="adddialogvisible"
      :before-close="addClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="addform" label-width="150px" ref="addref" :rules="rules">
        <el-form-item :label="$t('xt.quhao')" prop="code">
          <el-input type="number" v-model="addform.code"></el-input>
        </el-form-item>
        <el-form-item :label="$t('xt.zwmc')" prop="cnname">
          <el-input v-model="addform.cnname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('xt.ywmc')" prop="enname">
          <el-input v-model="addform.enname"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addsubmit">{{
          $t('tijiao')
        }}</el-button>
        <el-button @click="addClose">{{ $t('quxiao') }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑钱包分类弹窗区域 -->
    <el-dialog
      :title="$t('bianji')"
      :visible="editdialogvisible"
      :before-close="editclose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="addform"
        label-width="150px"
        ref="editref"
        :rules="rules"
      >
        <el-form-item :label="$t('xt.quhao')" prop="code">
          <el-input type="number" v-model="addform.code"></el-input>
        </el-form-item>
        <el-form-item :label="$t('xt.zwmc')" prop="cnname">
          <el-input v-model="addform.cnname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('xt.ywmc')" prop="enname">
          <el-input v-model="addform.enname"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editsubmit">{{
          $t('tijiao')
        }}</el-button>
        <el-button @click="editclose">{{ $t('quxiao') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 分页请求数据对象
      queryinfo: {
        query: '',
        page: 1
      },
      arealist: [],
      total: 0,
      loading: true,
      // 添加/编辑钱包数据对象
      addform: {
        code: '',
        cnname: '',
        enname: ''
      },
      // 编辑的id
      editid: '',
      adddialogvisible: false,
      rules: {
        code: [{ required: true, message: '请填区别', trigger: 'blur' }],
        cnnane: [
          { required: true, message: '请填写中文名称', trigger: 'blur' }
        ],
        enname: [{ required: true, message: '请填写英文名称', trigger: 'blur' }]
      },
      editdialogvisible: false
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    async getlist() {
      this.loading = true
      const { data } = await this.$http.get('/admin/system/arealist', {
        params: this.queryinfo
      })
      this.arealist = data.data.list
      this.loading = false
    },
    // 分页事件
    changepage(val) {
      this.queryinfo.page = val
      this.getlist()
    },
    // 添加分类弹窗
    addarea() {
      this.adddialogvisible = true
    },
    // 关闭添加弹窗
    addClose() {
      this.$refs.addref.resetFields()
      this.adddialogvisible = false
    },
    // 提交添加分类
    addsubmit() {
      this.$refs.addref.validate(async valid => {
        if (!valid) return false
        const { data } = await this.$http.post(
          '/admin/system/addarea',
          this.addform
        )
        if (data) {
          if (data.code === 200) {
            this.$message.success(this.getlang(data.msg))
            this.addClose()
            this.getlist()
          } else {
            this.$message.error(this.getlang(data.msg))
          }
        }
      })
    },
    // 打开编辑弹窗
    async edit(id) {
      this.editdialogvisible = true
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255,255, 255, 0.7)',
        target: document.querySelector('.el-dialog__body')
      })
      const { data } = await this.$http.get('/admin/system/editarea/id/' + id)
      this.addform.code = data.data.code
      this.addform.cnname = data.data.cnname
      this.addform.enname = data.data.enname
      this.editid = data.data.id
      loading.close()
    },
    // 编辑提交
    editsubmit() {
      this.$refs.editref.validate(async valid => {
        if (!valid) return false
        this.addform.id = this.editid
        const { data } = await this.$http.post(
          '/admin/system/editarea',
          this.addform
        )
        if (data) {
          if (data.code === 200) {
            this.$message.success(this.getlang(data.msg))
            this.editclose()
            this.getlist()
            this.editdialogvisible = false
          } else {
            this.$message.error(this.getlang(data.msg))
          }
        }
      })
    },
    // 关闭编辑弹窗
    editclose() {
      this.$refs.editref.resetFields()
      this.editdialogvisible = false
    },
    // 删除操作
    del(id) {
      this.$confirm(this.$t('chanchutips'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('queding'),
        type: 'warning'
      }).then(async () => {
        const { data } = await this.$http.post('/admin/system/delarea', {
          id
        })
        if (data) {
          if (data.code === 200) {
            this.$message.success(this.getlang(data.msg))
            this.getlist()
          } else {
            this.$message.error(this.getlang(data.msg))
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 15px;
  text-align: center;
}
.iconfont,
.el-icon-close {
  font-size: 18px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 15px;
  padding: 1px;
  &:hover {
    color: #409eff;
    cursor: pointer;
    border-color: #409eff;
  }
}
.el-select {
  min-width: 300px;
}
</style>
